// ─── Incident Domain ───

// Numeric enums matching backend Api.Models.IncidentSeverity
export enum IncidentSeverity {
  Informational = 0,
  Low = 1,
  Medium = 2,
  High = 3,
}

// Numeric enums matching backend Api.Models.IncidentState
export enum IncidentState {
  New = 0,
  Active = 3,
  Closed = 6,
}

// Enum matching backend Api.Models.SlaType
export enum SlaType {
  Ack = 0,
  Update = 1,
}

export enum SignalREventType {
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentUpdated = 'UPDATED',
  IncidentClosed = 'CLOSED',
  IncidentNotification = 'INCIDENT_NOTIFICATION',
  SlaWarning = 'SlaWarning',
  SlaBreached = 'SlaBreached',
}

export interface Incident {
  incidentId: string;
  incidentArmId?: string | null;
  customerId: string;
  severity: IncidentSeverity;
  state: IncidentState;
  title: string;
  assignedOperatorId: string | null;
  assignedOperatorName: string | null;
  acknowledgedTime: string | null;
  ownedTime: string | null;
  createdTime: string;
  lastUpdateTime: string;
  slaDeadline: string;
  escalationLevel: number;
  sentinelUrl: string | null;
  slaType: SlaType;
  tags?: IncidentTags | null;
}

export interface IncidentTags {
  isCritical: boolean;
  nis2Categories: string[];
}

export interface IncidentComment {
  id: string;
  message: string;
  authorName?: string | null;
  createdTimeUtc?: string | null;
  lastModifiedTimeUtc?: string | null;
}

export interface SlaConfig {
  severity: IncidentSeverity;
  ackSlaMinutes: number;
  updateSlaMinutes: number;
}

export interface SignalRMessage {
  eventType: SignalREventType;
  incidentId: string;
  severity: IncidentSeverity;
  state: IncidentState;
  customerId: string;
  incident?: Incident;
}

// ─── Auth / User ───

export enum UserRole {
  Supervisor = 'Supervisor',
  Analyst = 'Analyst',
  CustomerViewer = 'CustomerViewer',
}

export interface AppUser {
  id: string;
  displayName: string;
  email: string;
  role: UserRole;
  assignedCustomerIds: string[];
}

/**
 * Represents a user from the SOC operators security group
 * Used when assigning incident ownership
 */
export interface OperatorUser {
  /** Azure AD Object ID */
  id: string;
  /** User display name */
  displayName: string;
  /** User email / UPN */
  email: string;
  /** User's job title (optional) */
  jobTitle?: string;
}

// ─── API responses ───

export interface ApiResponse<T> {
  data: T;
  success: boolean;
  error?: string;
}

// ─── Status Panel view modes ───

export enum StatusPanelMode {
  WallScreen = 'wall-screen',
  Personal = 'personal',
}
